import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

//TODO::/error/404
import NotFound from '../views/404.vue';
//TODO::登录页
const Login = () => import('@/views/login');
const BusinessManage = () => import('@/views/business/manage'); //后台登录
// const Login = () => import('@/views/loginDemo');

//TODO::首页模块
const Home = () => import('@/views/home');
const HomePage = () => import('@/views/homePage');

//TODO::会员短信模块
//会员管理
const ManagementGradation = () => import('@/views/member-sms/management/gradation'); // 等级划分
const ManagementGrouping = () => import('@/views/member-sms/management/grouping'); // 会员分组
const ManagementOrderCrowd = () => import('@/views/member-sms/management/orderCrowd'); // 订单人群
const ManagementTag = () => import('@/views/member-sms/management/tag'); // 标签管理
const SceneMarketing = () => import('@/views/member-sms/recommend/scene-marketing'); // 场景营销
const CardSms = () => import('@/views/member-sms/recommend/card-sms'); // 卡片短信

//会员测试模块
const ManagementDemo = () => import('@/views/member-sms/demo/demo'); // 会员分组
//短信营销
const SmsMarketingMembersSend = () => import('@/views/member-sms/sms-marketing/members-send'); // 会员短信群发
const SmsSecondMemberSend = () => import('@/views/member-sms/sms-marketing/second-members-send'); // 二次会员营销
const SmsMarketingSecondMarket = () => import('@/views/member-sms/sms-marketing/second-market'); // 二次短信营销
const SmsMarketingNumberSend = () => import('@/views/member-sms/sms-marketing/number-send'); // 指定号码发送
const SmsMarketingOrderSend = () =>import('@/views/member-sms/sms-marketing/order-send')   //订单短信群发
const SmsMarketingTemplateManagement = () =>import('@/views/member-sms/sms-marketing/template-management')   //短信模板管理
const SmsMarketingBlackList = () =>import('@/views/member-sms/sms-marketing/blacklist')   //短信黑名单
const EffectSummary = () =>import('@/views/member-sms/sms-marketing/effect-summary')   //短信效果汇总
const SmsMarketingOrderGroupSend = () => import('@/views/member-sms/sms-marketing/orderGroup-send'); // 订单分组群发

// 订单关怀
const OrderSmsPlaceOrder = () => import('@/views/member-sms/order-sms/place-order'); //下单关怀
const OrderSmsPressPay = () => import('@/views/member-sms/order-sms/press-pay');  //催付提醒
const TwicePressPay = () => import('@/views/member-sms/order-sms/twice-press-pay');  //二次催付
const DepositPressPay = () => import('@/views/member-sms/order-sms/deposit-press-pay');  //预售定金催付
const FinalPressPay = () => import('@/views/member-sms/order-sms/final-press-pay');  //预售尾款催付
const JhsPressPay = () => import('@/views/member-sms/order-sms/jhs-press-pay');  //聚划算催付
const gbqPressPay = () => import('@/views/member-sms/order-sms/gbq-press-pay');  //订单关闭前催付
const PayCare = () => import('@/views/member-sms/order-sms/pay-care');  //付款关怀
const SmartAddPay = () => import('@/views/member-sms/order-sms/smart-add-pay');  //凑单提醒
const PressDelay = () => import('@/views/member-sms/order-sms/press-delay');  //延迟发货提醒
const DelayDeliver = () => import('@/views/member-sms/order-sms/delay-deliver');  //发货提醒
const Deliver = () => import('@/views/member-sms/order-sms/deliver');  //派送提醒
const LogisticsAOG = () => import('@/views/member-sms/order-sms/logistics-AOG');  //物流到货提醒
const signIn = () => import('@/views/member-sms/order-sms/signIn');  //签收提醒
const LogisticsAbnormal = () => import('@/views/member-sms/order-sms/logistics-abnormal');  //异常物流提醒
const BabyCare = () => import('@/views/member-sms/order-sms/baby-care');  //宝贝关怀
const BackMoneyCare = () => import('@/views/member-sms/order-sms/backMoney-care');  //回款关怀
const UrgeEva = () => import('@/views/member-sms/order-sms/urge-eva');  //催评价
const TwiceUrgeEva = () => import('@/views/member-sms/order-sms/twice-urge-eva');  //二次催评价
const EvaCare = () => import('@/views/member-sms/order-sms/eva-care');  //评价关怀
const EvaPacify = () => import('@/views/member-sms/order-sms/eva-pacify');  //中差评安抚
const ApplyRefund = () => import('@/views/member-sms/order-sms/apply-refund');  //申请退款提醒
const AllowRefund = () => import('@/views/member-sms/order-sms/allow-refund');  //同意退款提醒
const RefuseRefund = () => import('@/views/member-sms/order-sms/refuse-refund');  //拒绝退款提醒
const SuccessRefund = () => import('@/views/member-sms/order-sms/success-refund');  //退款成功提醒

// 自动化营销
const FullMoon = () => import('@/views/member-sms/auto-market/full-moon');  //满月礼
const Anniversary = () => import('@/views/member-sms/auto-market/anniversary');  //周年庆
const Dormant = () => import('@/views/member-sms/auto-market/dormant');  //休眠关怀
const HundredDay = () => import('@/views/member-sms/auto-market/hundred-day');  //百日礼

// 短信设置
const SmsSet = () => import('@/views/member-sms/set-sms/sms-set');  //短信设置
const SmsExpend = () => import('@/views/member-sms/set-sms/sms-expend');  //短信消耗

//TODO::商品模块
//商品管理
const CommodityManagement = () => import('@/views/commodity/management/commodity-management'); // 商品管理
const TitleOptimize = () => import('@/views/commodity/management/title-optimize'); // 标题优化
const BanWord = () => import('@/views/commodity/management/banWord'); // 违禁词检测
// 宝贝复制
const CopyBaby = () => import('@/views/commodity/baby-copy/copy-baby'); // 复制宝贝

// 手机详情
const MobileDetail = () => import('@/views/commodity/mobile-detail/mobile-detail'); // 手机详情
// 自动补库存
const StockSet = () => import('@/views/commodity/replenish-stock/stock-set'); // 补库存设置
const StockRecord = () => import('@/views/commodity/replenish-stock/stock-record'); // 补库存记录


//TODO::设置
//系统设置
const SetSign = () => import('@/views/set/set-sys/set-sign'); // 短信签名
const SetCertification = () => import('@/views/set/set-sys/set-certification'); // 资质申请
const VoucherCenter = () => import('@/views/set/set-sys/voucher-center'); // 充值中心
const Bill = () => import('@/views/set/set-sys/bill'); // 账单
const OperationRecord = () => import('@/views/set/set-sys/operation-record'); // 账单
const ExportCenter = () => import('@/views/set/set-sys/export-center'); // 导出中心

//TODO::营销
//促销活动
const ActiveList = () => import('@/views/market/promote-activity/active-list'); // 活动列表
const LimitedTimeDiscount = () => import('@/views/market/promote-activity/limitedTime-discount'); // 限时打折
const ActiveQuery = () => import('@/views/market/promote-activity/active-query'); // 限时打折

//权益管理
const StoreCoupons = () => import('@/views/market/equity-management/store-coupons'); // 店铺优惠券
const AlipayEnvelope = () => import('@/views/market/equity-management/alipay-envelope'); // 支付宝红包

//TODO::素材
//模板素材
const MaterialHomePage = () => import('@/views/material/template-material/material-homePage'); // 素材首页
const MaterialCenter = () => import('@/views/material/template-material/material-center'); // 素材中心

//TODO::订单
//订单管理
const BadIntercept = () => import('@/views/order-model/order-management/badIntercept'); //差评师拦截
const NoPurchaseInStore = () => import('@/views/order-model/order-management/noPurchaseInStore'); //全店禁购

//TODO::售后
//评价管理
const EvaHomepage = () => import('@/views/after-sales/evaluate-manage/eva-homepage'); //首页
const EvaDispose = () => import('@/views/after-sales/evaluate-manage/eva-dispose'); //中差评处理
const EvaAnalyse = () => import('@/views/after-sales/evaluate-manage/eva-analyse'); //中差评分析
const AutoEva = () => import('@/views/after-sales/evaluate-manage/auto-eva'); //自动评价
// 掌柜预警
const ManagerWarn = () => import('@/views/after-sales/manager-warn/manager-warn'); //掌柜预警
// 异常物流
const LogisticsTrace = () => import('@/views/after-sales/unu-logistics/logistics-trace'); //物流跟踪
//退货管理
const ReturnManagement = () => import('@/views/after-sales/return-handling/return-management'); //退货管理
const ReturnAlert = () => import('@/views/after-sales/return-handling/return-alert'); //退换货预警
const ReturnAnalysis = () => import('@/views/after-sales/return-handling/return-analysis'); //退货分析
const AutoAgreeToReturn = () => import('@/views/after-sales/return-handling/autoAgreeToReturn'); //自动同意退货
const AutoAgreeToRefund = () => import('@/views/after-sales/return-handling/autoAgreeToRefund'); //自动同意退款

//TODO::数据
//数据分析
const MemberLevAnaly = () => import('@/views/datum/data-analyse/member-lev-analy'); //会员等级分析
const UnitPriceAnaly = () => import('@/views/datum/data-analyse/unit-price-analy'); //笔单价分析
const TotalSumAnaly = () => import('@/views/datum/data-analyse/total-sum-analy'); //购买总额分析
const PurchaseFrequencyAnaly = () => import('@/views/datum/data-analyse/purchase-frequency-analy'); //购买频次分析
const RFMAnaly = () => import('@/views/datum/data-analyse/RFM-analy'); //RFM模型分析
const RFMMatrix = () => import('@/views/datum/data-analyse/RFM-matrix'); //RFM矩阵
const RFMTrait = () => import('@/views/datum/data-analyse/RFM-trait'); //RFM客户特征模型


// 操作说明
const explain = () => import('@/views/explain-page')
// 帮助中心
const help = () => import('@/views/help-page')

//处理路由跳转报错问题
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace


Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}


Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => err)
}
Vue.use(Router)

const routes =  [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/NotFound',
    name: 'NotFound',
    component: NotFound,
  },
//   { //后台登录
//     path: '/business/manage',
//     name: 'BusinessManage',
//     component: BusinessManage,
//   },
  {
    path: '/',
    name: 'Home',
    component: Home,
    children:[
		{ //首页
			path: '/homePage',
			name: 'HomePage',
			component: HomePage,
		},
		{ //会员管理
			path: '/member-sms/management/gradation',
			name: 'ManagementGradation',
			component: ManagementGradation,
		},
		{ //会员分组
			path: '/member-sms/management/grouping',
			name: 'ManagementGrouping',
			component: ManagementGrouping,
		},
		{ //订单人群
			path: '/member-sms/management/orderCrowd',
			name: 'ManagementOrderCrowd',
			component: ManagementOrderCrowd,
		},
		{ //标签管理
			path: '/member-sms/management/tag',
			name: 'ManagementTag',
			component: ManagementTag,
		},
		{ //场景营销
			path: '/member-sms/recommend/scene-marketing',
			name: 'SceneMarketing',
			component: SceneMarketing,
		},
		{ //卡片短信
			path: '/member-sms/recommend/card-sms',
			name: 'CardSms',
			component: CardSms,
		},
		{
			path: '/member-sms/demo/demo',
			name: 'ManagementDemo',
			component: ManagementDemo,			
		},
		{ // 会员短信群发
			path: '/member-sms/sms-marketing/members-send',
			name: 'SmsMarketingMembersSend',
			component: SmsMarketingMembersSend,			
		},
		{ // 二次会员营销
			path: '/member-sms/sms-marketing/second-members-send',
			name: 'SmsSecondMemberSend',
			component: SmsSecondMemberSend,			
		},
		{
			path: '/member-sms/sms-marketing/second-market',
			name: 'SmsMarketingSecondMarket',
			component: SmsMarketingSecondMarket,			
		},
		{
			path: '/member-sms/sms-marketing/number-send',
			name: 'SmsMarketingNumberSend',
			component: SmsMarketingNumberSend,			
		},
		{
			path: '/member-sms/sms-marketing/order-send',
			name: 'SmsMarketingOrderSend',
			component: SmsMarketingOrderSend,			
		},
		{
			path: '/member-sms/sms-marketing/orderGroup-send',
			name: 'SmsMarketingOrderGroupSend',
			component: SmsMarketingOrderGroupSend,			
		},											
		{
			path: '/member-sms/sms-marketing/template-management',
			name: 'SmsMarketingTemplateManagement',
			component: SmsMarketingTemplateManagement,
		},
		{
			path: '/member-sms/sms-marketing/blacklist',
			name: 'SmsMarketingBlackList',
			component: SmsMarketingBlackList,
		},
		{ //短信效果汇总
			path: '/member-sms/sms-marketing/effect-summary',
			name: 'EffectSummary',
			component: EffectSummary,
		},		
		{ //下单关怀
			path: '/member-sms/order-sms/place-order',
			name: 'OrderSmsPlaceOrder',
			component: OrderSmsPlaceOrder,
		},
		{  //催付提醒
			path: '/member-sms/order-sms/press-pay',
			name: 'OrderSmsPressPay',
			component: OrderSmsPressPay,
		},	
		{ //二次催付
			path: '/member-sms/order-sms/twice-press-pay',
			name: 'TwicePressPay',
			component: TwicePressPay,
		},	
		{  //预售定金催付
			path: '/member-sms/order-sms/deposit-press-pay',
			name: 'DepositPressPay',
			component: DepositPressPay,
		},		
		{  //预售尾款催付
			path: '/member-sms/order-sms/final-press-pay',
			name: 'FinalPressPay',
			component: FinalPressPay,
		},	
		{  //聚划算催付
			path: '/member-sms/order-sms/jhs-press-pay',
			name: 'JhsPressPay',
			component: JhsPressPay,
		},	
		{  //订单关闭前催付
			path: '/member-sms/order-sms/gbq-press-pay',
			name: 'gbqPressPay',
			component: gbqPressPay,
		},	
		{  //付款关怀
			path: '/member-sms/order-sms/pay-care',
			name: 'PayCare',
			component: PayCare,
		},	
		{ //凑单提醒
			path: '/member-sms/order-sms/smart-add-pay',
			name: 'SmartAddPay',
			component: SmartAddPay,
		},	
		{  //延迟发货提醒
			path: '/member-sms/order-sms/press-delay',
			name: 'PressDelay',
			component: PressDelay,
		},	
		{ //发货提醒
			path: '/member-sms/order-sms/delay-deliver',
			name: 'DelayDeliver',
			component: DelayDeliver,
		},	
		{ //派送提醒
			path: '/member-sms/order-sms/deliver',
			name: 'Deliver',
			component: Deliver,
		},	
		{ //物流到货提醒
			path: '/member-sms/order-sms/logistics-AOG',
			name: 'LogisticsAOG',
			component: LogisticsAOG,
		},	
		{  //签收提醒
			path: '/member-sms/order-sms/signIn',
			name: 'signIn',
			component: signIn,
		},	
		{  //异常物流提醒
			path: '/member-sms/order-sms/logistics-abnormal',
			name: 'LogisticsAbnormal',
			component: LogisticsAbnormal,
		},	
		{  //宝贝关怀
			path: '/member-sms/order-sms/baby-care',
			name: 'BabyCare',
			component: BabyCare,
		},	
		{  //回款关怀
			path: '/member-sms/order-sms/backMoney-care',
			name: 'BackMoneyCare',
			component: BackMoneyCare,
		},	
		{ //催评价
			path: '/member-sms/order-sms/urge-eva',
			name: 'UrgeEva',
			component: UrgeEva,
		},	
		{  //二次催评价
			path: '/member-sms/order-sms/twice-urge-eva',
			name: 'TwiceUrgeEva',
			component: TwiceUrgeEva,
		},	
		{  //评价关怀
			path: '/member-sms/order-sms/eva-care',
			name: 'EvaCare',
			component: EvaCare,
		},	
		{  //中差评安抚
			path: '/member-sms/order-sms/eva-pacify',
			name: 'EvaPacify',
			component: EvaPacify,
		},	
		{  //申请退款提醒
			path: '/member-sms/order-sms/apply-refund',
			name: 'ApplyRefund',
			component: ApplyRefund,
		},
		{  //同意退款提醒
			path: '/member-sms/order-sms/allow-refund',
			name: 'AllowRefund',
			component: AllowRefund,
		},
		{  //拒绝退款提醒
			path: '/member-sms/order-sms/refuse-refund',
			name: 'RefuseRefund',
			component: RefuseRefund,
		},
		{  //退款成功提醒
			path: '/member-sms/order-sms/success-refund',
			name: 'SuccessRefund',
			component: SuccessRefund,
		},
		{  //满月礼
			path: '/member-sms/auto-market/full-moon',
			name: 'FullMoon',
			component: FullMoon,
		},
		{  //周年庆
			path: '/member-sms/auto-market/anniversary',
			name: 'Anniversary',
			component: Anniversary,
		},
		{  //休眠关怀
			path: '/member-sms/auto-market/dormant',
			name: 'Dormant',
			component: Dormant,
		},
		{  //百日礼
			path: '/member-sms/auto-market/hundred-day',
			name: 'HundredDay',
			component: HundredDay,
		},
		{  //短信设置
			path: '/member-sms/sms-set/sms-set',
			name: 'SmsSet',
			component: SmsSet,
		},
		{  //短信消耗
			path: '/member-sms/sms-set/sms-expend',
			name: 'SmsExpend',
			component: SmsExpend,
		},
		


		{ // 商品管理
			path: '/commodity/management/commodity-management',
			name: 'CommodityManagement',
			component: CommodityManagement,			
		},
		{ // 标题优化
			path: '/commodity/management/title-optimize',
			name: 'TitleOptimize',
			component: TitleOptimize,			
		},
		{ // 违禁词检测
			path: '/commodity/management/banWord',
			name: 'BanWord',
			component: BanWord,			
		},
		{ // 复制宝贝
			path: '/commodity/baby-copy/copy-baby',
			name: 'CopyBaby',
			component: CopyBaby,			
		},
		{ // 手机详情
			path: '/commodity/mobile-detail/mobile-detail',
			name: 'MobileDetail',
			component: MobileDetail,			
		},
		{ // 补库存设置
			path: '/commodity/replenish-stock/stock-set',
			name: 'StockSet',
			component: StockSet,			
		},
		{ // 补库存设置
			path: '/commodity/replenish-stock/stock-record',
			name: 'StockRecord',
			component: StockRecord,			
		},

		{ // 短信签名
			path: '/set/set-sys/set-sign',
			name: 'SetSign',
			component: SetSign,			
		},
		{ // 资质申请
			path: '/set/set-sys/set-certification',
			name: 'SetCertification',
			component: SetCertification,			
		},
		{ // 充值中心
			path: '/set/set-sys/voucher-center',
			name: 'VoucherCenter',
			component: VoucherCenter,			
		},	
		{ // 账单
			path: '/set/set-sys/bill',
			name: 'Bill',
			component: Bill,			
		},
		{ // 操作记录
			path: '/set/set-sys/operation-record',
			name: 'OperationRecord',
			component: OperationRecord,
		},
		{ // 导出中心
			path: '/set/set-sys/export-center',
			name: 'ExportCenter',
			component: ExportCenter,
		},
		// 促销活动
		{ // 活动列表
			path: '/market/promote-activity/active-list',
			name: 'ActiveList',
			component: ActiveList,
		},
		{ // 限时打折
			path: '/market/promote-activity/limitedTime-discount',
			name: 'LimitedTimeDiscount',
			component: LimitedTimeDiscount,
		},
		{ // 商品活动查询
			path: '/market/promote-activity/active-query',
			name: 'ActiveQuery',
			component: ActiveQuery,
		},
		
		// 权益管理
		{	// 店铺优惠券
			path: '/market/equity-management/store-coupons',
			name: 'StoreCoupons',
			component: StoreCoupons,
		},
		{	// 支付宝红包
			path: '/market/equity-management/alipay-envelope',
			name: 'AlipayEnvelope',
			component: AlipayEnvelope,
		},		

		// 模板素材
		{ // 素材首页
			path: '/material/template-material/material-homePage',
			name: 'MaterialHomePage',
			component: MaterialHomePage,
		},
		{ // 素材中心
			path: '/material/template-material/material-center',
			name: 'MaterialCenter',
			component: MaterialCenter,
		},
		// 评价管理
		{ // 首页
			path: '/after-sales/evaluate-manage/eva-homepage',
			name: 'EvaHomepage',
			component: EvaHomepage,
		},
		{ // 中差评处理
			path: '/after-sales/evaluate-manage/eva-dispose',
			name: 'EvaDispose',
			component: EvaDispose,
		},
		{ // 中差评分析
			path: '/after-sales/evaluate-manage/eva-analyse',
			name: 'EvaAnalyse',
			component: EvaAnalyse,
		},
		{ // 自动评价
			path: '/after-sales/evaluate-manage/auto-eva',
			name: 'AutoEva',
			component: AutoEva,
		},
		{ // 掌柜预警
			path: '/after-sales/manager-warn/manager-warn',
			name: 'ManagerWarn',
			component: ManagerWarn,
		},
		{ // 物流跟踪
			path: '/after-sales/unu-logistics/logistics-trace',
			name: 'LogisticsTrace',
			component: LogisticsTrace,
		},
		// 数据分析
		{ // 会员等级分析
			path: '/datum/data-analyse/member-lev-analy',
			name: 'MemberLevAnaly',
			component: MemberLevAnaly,
		},
		{ // 笔单价分析
			path: '/datum/data-analyse/unit-price-analy',
			name: 'UnitPriceAnaly',
			component: UnitPriceAnaly,
		},
		{ // 购买总额分析
			path: '/datum/data-analyse/total-sum-analy',
			name: 'TotalSumAnaly',
			component: TotalSumAnaly,
		},
		{ // 购买频次分析
			path: '/datum/data-analyse/purchase-frequency-analy',
			name: 'PurchaseFrequencyAnaly',
			component: PurchaseFrequencyAnaly,
		},
		{ // RFM模型分析
			path: '/datum/data-analyse/RFM-analy',
			name: 'RFMAnaly',
			component: RFMAnaly,
		},
		{ // RFM矩阵
			path: '/datum/data-analyse/RFM-matrix',
			name: 'RFMMatrix',
			component: RFMMatrix,
		},
		{ // RFM客户特征模型
			path: '/datum/data-analyse/RFM-trait',
			name: 'RFMTrait',
			component: RFMTrait,
		},

		{ // 退货管理
			path: '/after-sales/return-handling/return-management',
			name: 'ReturnManagement',
			component: ReturnManagement,
		},
		{ // 退换货预警
			path: '/after-sales/return-handling/return-alert',
			name: 'ReturnAlert',
			component: ReturnAlert,
		},
		{ // 退货分析
			path: '/after-sales/return-handling/return-analysis',
			name: 'ReturnAnalysis',
			component: ReturnAnalysis,
		},		
		{ // 自动同意退货
			path: '/after-sales/return-handling/autoAgreeToReturn',
			name: 'AutoAgreeToReturn',
			component: AutoAgreeToReturn,
		},
		{ // 自动同意退款
			path: '/after-sales/return-handling/autoAgreeToRefund',
			name: 'AutoAgreeToRefund',
			component: AutoAgreeToRefund,
		},								
		{ // 差评拦截
			path: '/order-model/order-management/badIntercept',
			name: 'BadIntercept',
			component: BadIntercept,
		},
		{ // 全店禁购
			path: '/order-model/order-management/noPurchaseInStore',
			name: 'NoPurchaseInStore',
			component: NoPurchaseInStore,
		},	
		{ //操作说明
			path: '/explain-page',
			name: 'explain',
			component: explain,
		},
		{ //帮助中心
			path: '/help-page',
			name: 'help',
			component: help,
		},					
    ]
  }
]

/**
 * 配置路由对象
 */
 const router = new Router({
	routes,
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		if(savedPosition) {
			return savedPosition;
		}
		return {
			x: 0,
			y: 0
		};
	}
});

//TODO:: 简单配置
//TODO:: NProgress.inc(0.2)
NProgress.configure({
	easing: 'ease',
	speed: 500,
	showSpinner: false
})
// TODO:: 路由拦截器，检测用户是否登录
router.beforeEach((to, from, next) => {
  //路由开始跳转
  NProgress.start();
  if (to.matched.length ===0) {
	console.log('?code='+to.query.code)
    next("/NotFound");
  }else{
    to.query.t = new Date().getTime();
    let user = JSON.parse(sessionStorage.getItem("BUYER-USER-INFO"));
	let token = localStorage.getItem("ACCESS-TOKEN")
    // 调试模式输出跳转日志
    console.info('------------------------------------------------------------------------------------------------');
    console.log(
      '目标路由', '名称:【' + to.name + '】',
      '地址:【' + to.fullPath + '】',
      '参数:【' + JSON.stringify(to.query) + '】',
    	'路由参数:【' + JSON.stringify(to.meta) + '】'
    );
    if(to.path != "/login") { //登录页面放过
		if (to.path == "/business/manage") {
			next();
		} else if(token) {
    		//获取到用户信息
    		if(__DEBUG__) {
    			console.log('当前用户基本信息', JSON.stringify(user));
    			// console.log('是否有当前页权限', user.functionObj[to.meta.id]?"有权限":"无权限");
    		}
    		if(to.path == '/') { //跳转到首页
    			next('/homePage');
    		} else {
    			//TODO：做权限判断
    			/*if(to.meta.id && !user.functionObj[to.meta.id]){
          	router.app.$Modal.confirm({
    			title: '提示',
    			okText: '去升级',
    			content: `<p>该功能属于全能版功能，当前版本${user.subscriber.appVersionName}。</p><p>升级全能版畅享更多优质服务。</p>`,
    			onOk: ()=> {
    				window.open('https://fuwu.taobao.com/ser/detail.htm?spm=a1z13.8114210.1234-fwlb.4.259a5aca9uPvjJ&service_code=ts-13075&tracelog=search&from_key=%E6%B7%98%E5%93%81%E5%AE%9D')
    			}
    		});
          }else{
          	next();
          }*/
    			next();
    		}
    	} else {
    		console.log('当前用户', '未登录的账户');
    		//没有用户信息跳登录页面
    		next('/login');
    	}
    } else {
    	next();
    }
  }

	console.info('------------------------------------------------------------------------------------------------');
});

// TODO:: 路由完成之后的操作
router.afterEach(route => {
	NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js